webpackJsonp([5],{

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/vue/dist/vue.runtime.esm.js
var vue_runtime_esm = __webpack_require__("/5sW");

// EXTERNAL MODULE: ./node_modules/vuetify/dist/vuetify.js
var vuetify = __webpack_require__("3EgV");
var vuetify_default = /*#__PURE__*/__webpack_require__.n(vuetify);

// EXTERNAL MODULE: ./node_modules/vuetify/dist/vuetify.css
var dist_vuetify = __webpack_require__("QCv7");
var dist_vuetify_default = /*#__PURE__*/__webpack_require__.n(dist_vuetify);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/App.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var App = ({
  data: function data() {
    return {
      sidebar: false
    };
  },

  computed: {
    appTitle: function appTitle() {
      return this.$store.getters.appTitle;
    },
    isAuthenticated: function isAuthenticated() {
      return this.$store.getters.getUser !== null && this.$store.getters.getUser !== undefined;
    },
    menuItems: function menuItems() {
      if (this.isAuthenticated) {
        return [{ title: 'Home', path: '/home', icon: 'home' }];
      } else {
        return [{ title: 'Sign Up', path: '/signup', icon: 'face' }, { title: 'Sign In', path: '/signin', icon: 'lock_open' }];
      }
    }
  },
  methods: {
    userSignOut: function userSignOut() {
      this.$store.dispatch('userSignOut');
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5fcc6800","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
var App_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[_c('v-navigation-drawer',{attrs:{"fixed":"","temporary":"","app":""},model:{value:(_vm.sidebar),callback:function ($$v) {_vm.sidebar=$$v},expression:"sidebar"}},[_c('v-list',[_vm._l((_vm.menuItems),function(item){return _c('v-list-tile',{key:item.title,attrs:{"to":item.path}},[_c('v-list-tile-action',[_c('v-icon',[_vm._v(_vm._s(item.icon))])],1),_vm._v(" "),_c('v-list-tile-content',[_vm._v(_vm._s(item.title))])],1)}),_vm._v(" "),(_vm.isAuthenticated)?_c('v-list-tile',{on:{"click":_vm.userSignOut}},[_c('v-list-tile-action',[_c('v-icon',[_vm._v("exit_to_app")])],1),_vm._v(" "),_c('v-list-tile-content',[_vm._v("Sign Out")])],1):_vm._e()],2)],1),_vm._v(" "),_c('v-toolbar',{attrs:{"fixed":"","app":""}},[_c('span',{staticClass:"hidden-sm-and-up"},[_c('v-toolbar-side-icon',{on:{"click":function($event){$event.stopPropagation();_vm.sidebar = !_vm.sidebar}}})],1),_vm._v(" "),_c('v-toolbar-title',[_c('router-link',{staticStyle:{"cursor":"pointer"},attrs:{"to":"/","tag":"span"}},[_vm._v("\n        "+_vm._s(_vm.appTitle)+"\n      ")])],1),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-toolbar-items',{staticClass:"hidden-xs-only"},[_vm._l((_vm.menuItems),function(item){return _c('v-btn',{key:item.title,attrs:{"flat":"","to":item.path}},[_c('v-icon',{attrs:{"left":""}},[_vm._v(_vm._s(item.icon))]),_vm._v("\n        "+_vm._s(item.title)+"\n      ")],1)}),_vm._v(" "),(_vm.isAuthenticated)?_c('v-btn',{attrs:{"flat":""},on:{"click":_vm.userSignOut}},[_c('v-icon',{attrs:{"left":""}},[_vm._v("exit_to_app")]),_vm._v("\n        Sign Out\n      ")],1):_vm._e()],2)],1),_vm._v(" "),_c('v-content',[_c('main',[_c('v-container',{attrs:{"fluid":"","fill-height":""}},[_c('router-view')],1)],1)]),_vm._v(" "),_c('v-footer',{attrs:{"app":""}})],1)}
var staticRenderFns = []
var esExports = { render: App_render, staticRenderFns: staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_App = (esExports);
// CONCATENATED MODULE: ./src/App.vue
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  App,
  selectortype_template_index_0_src_App,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var src_App = (Component.exports);

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/toConsumableArray.js
var toConsumableArray = __webpack_require__("Gu7T");
var toConsumableArray_default = /*#__PURE__*/__webpack_require__.n(toConsumableArray);

// EXTERNAL MODULE: ./node_modules/vue-router/dist/vue-router.esm.js
var vue_router_esm = __webpack_require__("/ocq");

// EXTERNAL MODULE: ./node_modules/firebase/index.js
var firebase = __webpack_require__("Sazm");
var firebase_default = /*#__PURE__*/__webpack_require__.n(firebase);

// EXTERNAL MODULE: ./src/components/NotFound.vue + 2 modules
var NotFound = __webpack_require__("YcJa");

// CONCATENATED MODULE: ./src/router/index.js






var routerOptions = [{ path: '/', component: 'Landing' }, { path: '/signin', component: 'Signin' }, { path: '/signup', component: 'Signup' }, { path: '/home', component: 'Home', meta: { requiresAuth: true } }];

var routes = routerOptions.map(function (route) {
  return {
    path: route.path,
    component: function component() {
      return __webpack_require__("mUJ2")("./" + route.component + '.vue');
    },
    meta: route.meta
  };
});

vue_runtime_esm["a" /* default */].use(vue_router_esm["a" /* default */]);

var router = new vue_router_esm["a" /* default */]({
  mode: 'history',
  routes: [].concat(toConsumableArray_default()(routes), [{ path: '*', component: NotFound["default"] }])
});

router.beforeEach(function (to, from, next) {
  var requiresAuth = to.matched.some(function (record) {
    return record.meta.requiresAuth;
  });
  var user = firebase_default.a.auth().currentUser;
  if (requiresAuth && !user) {
    next('/signin');
  }
  next();
});

/* harmony default export */ var src_router = (router);
// EXTERNAL MODULE: ./node_modules/vuex/dist/vuex.esm.js
var vuex_esm = __webpack_require__("NYxO");

// CONCATENATED MODULE: ./src/store/state.js
var state = {
  appTitle: 'PinLabs Inc.',
  user: null,
  error: null,
  loading: false
};
// CONCATENATED MODULE: ./src/store/mutations.js
var mutations = {
  setUser: function setUser(state, payload) {
    state.user = payload;
  },
  setError: function setError(state, payload) {
    state.error = payload;
  },
  setLoading: function setLoading(state, payload) {
    state.loading = payload;
  }
};
// CONCATENATED MODULE: ./src/store/actions.js


var actions = {
  autoSignIn: function autoSignIn(_ref, payload) {
    var commit = _ref.commit;

    commit('setUser', payload);
  },
  userSignUp: function userSignUp(_ref2, payload) {
    var commit = _ref2.commit;

    commit('setLoading', true);
    firebase_default.a.auth().createUserWithEmailAndPassword(payload.email, payload.password).then(function (firebaseUser) {
      commit('setUser', firebaseUser);
      commit('setLoading', false);
      commit('setError', null);
      src_router.push('/home');
    }).catch(function (error) {
      commit('setError', error.message);
      commit('setLoading', false);
    });
  },
  userSignIn: function userSignIn(_ref3, payload) {
    var commit = _ref3.commit;

    commit('setLoading', true);
    firebase_default.a.auth().signInWithEmailAndPassword(payload.email, payload.password).then(function (firebaseUser) {
      commit('setUser', firebaseUser);
      commit('setLoading', false);
      commit('setError', null);
      src_router.push('/home');
    }).catch(function (error) {
      commit('setError', error.message);
      commit('setLoading', false);
    });
  },
  userSignOut: function userSignOut(_ref4) {
    var commit = _ref4.commit;

    firebase_default.a.auth().signOut();
    commit('setUser', null);
    src_router.push('/');
  }
};
// CONCATENATED MODULE: ./src/store/getters.js
var getters = {
  appTitle: function appTitle(state) {
    return state.appTitle;
  },
  getUser: function getUser(state) {
    return state.user;
  },
  getError: function getError(state) {
    return state.error;
  },
  getLoading: function getLoading(state) {
    return state.loading;
  }
};
// CONCATENATED MODULE: ./src/store/index.js








vue_runtime_esm["a" /* default */].use(vuex_esm["a" /* default */]);

var store = new vuex_esm["a" /* default */].Store({
  state: state,
  mutations: mutations,
  actions: actions,
  getters: getters
});
// CONCATENATED MODULE: ./src/config.js
var firebaseConfig = {
  apiKey: 'AIzaSyBTM8beHvLFZx5cgeZ-rdwr8K4vvp0damQ',
  authDomain: 'fir-app-ce0af.firebaseapp.com',
  databaseURL: 'https://fir-app-ce0af.firebaseio.com',
  projectId: 'fir-app-ce0af',
  storageBucket: 'fir-app-ce0af.appspot.com',
  messagingSenderId: '158248257657'
};
// CONCATENATED MODULE: ./src/main.js









vue_runtime_esm["a" /* default */].use(vuetify_default.a);
vue_runtime_esm["a" /* default */].config.productionTip = false;

firebase_default.a.initializeApp(firebaseConfig);

/* eslint-disable no-new */
var unsubscribe = firebase_default.a.auth().onAuthStateChanged(function (firebaseUser) {
  new vue_runtime_esm["a" /* default */]({
    el: '#app',
    router: src_router,
    store: store,
    render: function render(h) {
      return h(src_App);
    },
    created: function created() {
      store.dispatch('autoSignIn', firebaseUser);
    }
  });
  unsubscribe();
});

/***/ }),

/***/ "QCv7":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "YcJa":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/NotFound.vue
//
//
//
//
//
//
//
//
//

/* harmony default export */ var NotFound = ({});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1d55c4b6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/NotFound.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{attrs:{"column":""}},[_c('v-flex',{staticClass:"text-xs-center",attrs:{"xs12":"","mt-5":""}},[_c('h3',[_vm._v("Error 404")]),_vm._v(" "),_c('h5',[_vm._v("Oops, looks like your link is incorrect")])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var components_NotFound = (esExports);
// CONCATENATED MODULE: ./src/components/NotFound.vue
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  NotFound,
  components_NotFound,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var src_components_NotFound = __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "mUJ2":
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./Home.vue": [
		"lO7g",
		3
	],
	"./Landing.vue": [
		"X4if",
		2
	],
	"./NotFound.vue": [
		"YcJa"
	],
	"./Signin.vue": [
		"Asuo",
		1
	],
	"./Signup.vue": [
		"psOb",
		0
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "mUJ2";
module.exports = webpackAsyncContext;

/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.66703e5c2fdb16abe489.js